/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Filter_MeInputs */

const fr_household_filter_me = /** @type {(inputs: Household_Filter_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moi`)
};

/**

* @param {Household_Filter_MeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_filter_me = /** @type {((inputs?: Household_Filter_MeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Filter_MeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_filter_me(inputs)
});